import React from 'react'
import { useTranslation } from 'react-i18next'
import { NavLink, useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import Responsive from '../../../assets/config/Responsive'
import Logo from '../../../assets/icons/JSX/Logo'
import LogoGe from '../../../assets/icons/JSX/LogoGe'
import PlusIcon from '../../../assets/icons/JSX/PlusIcon'
import PolicyIcon from '../../../assets/icons/JSX/PolicyIcon'
import TransactionsIcon from '../../../assets/icons/JSX/TransactionsIcon'
import Colors from '../../../assets/styles/Colors'
import { useAppSelector } from '../../../store'
import { AppState } from '../../../store/appSlice'
import LoggedUserHeader from './LoggedUserHeader'
import IAIcon from '../../../assets/icons/JSX/AIIcon'

const LoggedUserLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const navigate = useNavigate()
  const { lang } = useAppSelector((root: { app: AppState }) => root.app)
  const { t } = useTranslation()

  return (
    <Wrapper>
      <SideBar>
        <SideBarContent>
          <SideBarUl>
            {lang === 'ge' ? (
              <LogoGeStyle onClick={() => navigate('/')} />
            ) : (
              <LogoStyle onClick={() => navigate('/')} />
            )}

            <NewPolicyBtn onClick={() => navigate('/category')}>
              <PlusIcon /> <span>{t('newPolicy')}</span>
            </NewPolicyBtn>
            <SideBarLi>
              <NavLinkStyle to={'/my-policies'}>
                <PolicyIcon /> <span>{t('myPolicies')}</span>
              </NavLinkStyle>
            </SideBarLi>
            <SideBarLi>
              <NavLinkStyle to={'/transactions'}>
                <TransactionsIcon /> <span>{t('transactions')}</span>
              </NavLinkStyle>
            </SideBarLi>
            <SideBarLi style={{ position: 'relative' }}>
              <BetaBadge>Beta</BetaBadge>
              <NavLinkStyle to={'/ai-assistent'}>
                <IAIcon /> <span>{t('ai_assistent')}</span>
              </NavLinkStyle>
            </SideBarLi>
          </SideBarUl>
        </SideBarContent>
      </SideBar>

      <Content>
        <LoggedUserHeader />
        <Children>{children}</Children>
      </Content>
    </Wrapper>
  )
}

//
const SideBar = styled.div`
  position: fixed;
  height: 100%;
  overflow: auto;
  background-color: ${Colors.white};
  width: 450px;
  padding: 56px 80px 60px 100px;

  ${Responsive.laptop} {
    padding: 46px 50px 40px 50px;
    width: 320px;
  }
  ${Responsive.tablet} {
    display: none;
  }
  ${Responsive.mobile} {
    display: none;
  }
`
const Content = styled.div`
  padding: 56px 80px 25px 80px;
  background-color: ${Colors.backgroundGrey};
  margin-left: 450px;
  min-height: 100dvh;

  ${Responsive.laptop} {
    padding: 46px 50px 25px 50px;
    margin-left: 320px;
  }
  ${Responsive.tablet} {
    padding: 0px;
    margin-left: 0px;
  }
  ${Responsive.mobile} {
    padding: 0px;
    margin-left: 0px;
  }
`
const NavLinkStyle = styled(NavLink)`
  color: inherit;
  text-decoration: none;
  display: flex;
  align-items: center;
  &.active {
    color: ${Colors.primaryBlack};
    svg {
      color: ${Colors.primaryBlack};
    }
  }
  &:hover {
    color: inherit;
  }
`
const Children = styled.div`
  padding-top: 30px;
  height: 100%;
  ${Responsive.tablet} {
    padding: 20px;
  }
  ${Responsive.mobile} {
    padding: 20px;
    height: calc(100dvh - 65px);
  }
`
const NewPolicyBtn = styled.button`
  width: 100%;
  border: 0px;
  outline: none;
  border-radius: 4px;
  background-color: ${Colors.primaryRed};
  color: ${Colors.white};
  height: 56px;
  margin-bottom: 40px;
  svg {
    transform: scale(1.05);
    width: 10px;
    margin-right: 10px;
    margin-top: -3px;
    color: ${Colors.white};
  }
`
const SideBarLi = styled.li`
  padding-top: 15px;
  padding-bottom: 15px;
  margin-top: 10px;
  margin-bottom: 10px;
  color: ${Colors.primaryGrey};

  /* side bar li text */
  span {
    font-size: 18px;
    line-height: 28px;
  }

  /* sibar bar li icons */
  svg {
    color: ${Colors.primaryGrey};
    width: 22px;
    height: 22px;
    margin-right: 28px;
    margin-top: -3px;
    min-width: 22px;
  }

  /* hover */
  &:hover {
    color: ${Colors.primaryBlack};
    svg {
      color: ${Colors.primaryBlack};
    }
  }
`
const SideBarUl = styled.ul`
  list-style: none;
  padding-left: 0px;
`
const SideBarContent = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  /* justify-content: space-between; */
`
const LogoStyle = styled(Logo)`
  width: 96px;
  margin-bottom: 60px;
  cursor: pointer;
  height: fit-content;
`
const LogoGeStyle = styled(LogoGe)`
  width: 96px;
  margin-bottom: 60px;
  cursor: pointer;
  height: fit-content;
`
const Wrapper = styled.div`
  min-height: 100dvh;
`
const BetaBadge = styled.span`
  position: absolute;
  top: 21px;
  right: -2px;
  background-color: ${Colors.primaryRed};
  color: ${Colors.white};
  font-size: 12px !important;
  font-weight: 600;
  padding: 4px 7px;
  border-radius: 12px;
  text-transform: uppercase;
  letter-spacing: 1px;
  line-height: 10px !important;
  z-index: 1;
  pointer-events: none;
  user-select: none;
`
export default LoggedUserLayout
